import React from "react";
import "../style/description.css"; // Ensure the correct file extension

const BottomDescription = () => {
  return (
    <div className="description-text">
      {/* Fixed className */}
      <h3 className="desc-text">
        Thank you for visiting our page! We hope you trust in our construction
        expertise and look forward to building your dream project with you. 😊🏗️
      </h3>
    </div>
  );
};

export default BottomDescription;
